import styled from 'styled-components';

import { Button as ButtonLayoutComponent, Segment, Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

export const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  padding-top: 20px;
  width: 100%;
`;

export const ContainerTitle = styled.div`
  width: 800px;
`;

export const Typography = styled(TextLayoutComponent)`
  font-size: 18px;
  margin-bottom: 10px;
  font-weight: 500;
  align-self: flex-start;
`;

export const DownloadContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  padding: 10px;
  margin: 20px 0;
`;

export const Content = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
`;

export const Image = styled.img`
  height: 90px;
  width: 90px;
`;

export const Button = styled(ButtonLayoutComponent)`
  &.ui.button {
    margin-top: 20px;
    width: 170px;
  }
`;

export const DownloadApplicationMessage = styled(TextLayoutComponent)`
  font-size: 18px;
  margin-top: 20px;
  text-align: center;
`;

export const DownloadApplicationLink = styled.a``;

export const DownloadLink = styled.button`
  all: unset;
  margin-top: 10px;
  font-weight: 500;
  padding: 5px;
  color: #477ae9;
  cursor: pointer;

  &:hover {
    color: #1954d3;
  }
`;

export const TutorialLink = styled.a``;

export const LinkMessage = styled(TextLayoutComponent)`
  font-size: 18px;
  max-width: 600px;
  text-align: center;
`;

export const HelpMessage = styled(TextLayoutComponent)`
  padding: 20px 10px;
  font-size: 14px;
  text-align: center;
`;

export const ContainerField = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 15px 0;
  &&& > div {
    width: 300px;
    margin: 0 10px;
  }
`;

export const Section = styled(Segment)`
  width: 800px;
  &&& {
  margin: 5px 0;
  padding: 20px;
  }
`;

export const ContainerStep = styled.div`
  display: flex;
`;

export const TimerDescription = styled(TextLayoutComponent)`
  width: max-content;
  flex-wrap: nowrap;
  padding-left: 5px;
`;

export const YourCodeText = styled(TextLayoutComponent)`
  font-weight: 500;
`;

export const DescriptionStep = styled(TextLayoutComponent)`
  width: 570px;
  flex-wrap: nowrap;
  padding-left: 5px;
`;

export const StepText = styled.p`
  font-weight: 600;
  display: inline;
`;

export const HelpLink = styled.a`
  font-weight: 500;
  display: flex;
  justify-content: flex-end;
  margin: 10px;
`;
